import { Search } from "@mui/icons-material";

const translations = {
  en: {
    next: "next",
    previous: "previous",
    submitdata: "submit",
    savedata: "save",
    welcome: "Welcome",
    language: "Language",
    operator: "Operator",
    pilot: "Pilot",
    operation: "Operation",
    registerdrone: "RegisterDrone",
    registerremoteid: "RegisterRemote ID",
    managedrone: "ManageDrone",
    managepilot: "ManagePilot",
    statusoperation: "StatusOperation",
    registerpilotopen: "RegisterPilotOpen",
    registerpilotspacific: "RegisterPilotSpacific",
    manageflightoperation: "ManageOperator",
    historyflight: "HistoryFlight",
    droneoperation: "DroneOperation",
    joinoperation: "JoinOperation",
    opeartiondisplay: "OperationDisplay",
    monitoring: "Monitoring",
    profile: "Profile",
    logout: "Logout",
    droneinfo: "Droneinfo",
    serialnumber: "Serialnumber",
    brand: "Brand",
    model: "Model",
    eq_install: "Equipment Install",
    weight: "Weight (Kg)",
    stdrid: "Have Built-in Remote ID ",
    registerRadio: "Radio communication equipment",
    frequency: {
      head: "Frequency (MHz) and isotropic equivalent broadcast power",
      1: "433.05 – 434.79 MHz Maximum transmit power e.i.r.p. 10 mW",
      2: "2400 – 2500 MHz Maximum transmit power e.i.r.p. 100 mW",
      3: "5725 – 5850 MHz Maximum transmit power e.i.r.p. 1000 mW",
      4: "24.05 – 24.25 GHz Maximum transmit power e.i.r.p. 100 mW",
    },
    purpose: {
      head: "Purpose of using aircraft",
      1: "Hobby,Entertainment or Sport",
      2: "Journalist or traffic report(Mass communication)",
      3: "Photography,Videography or TV-Filming",
      4: "Agriculture",
      5: "Research and development of commercial aircraft",
      6: "Research,experiment, test according to the NBTC announcement",
      7: "Other purpose,specify",
      8: "Survey or inspect buildings",
      9: "Survey or aerial photography",
      10: "Operations for display",
      11: "Operation beyond visual range of the pilot using visual assist (EVLOS)",
      12: "Closed space operations",
      13: "Organizing a drone competition",
      etc: "Other, please specify",
      open1: "For research",
    },
    remote_sn: "Flight control device serial number",
    remote_brand: "Flight control equipment brand",
    lic: {
      head: "Date of possession of radio communication equipment used in unmanned aircraft",
      1: "Imported according to the Import License",
      101: "Import license number",
      102: "Import date (d/M/yyyy)",
      2: "Purchased from the distributor/store",
      201: "Store name",
      202: "Bill date (d M yyyy)",
      3: "Temporarilty imported in to the country",
      301: "Arrival date (mm dd, yyyy)",
      302: "Number of days of stay in Thailand (days)",
      4: "Transfered from the others",
      5: "Made according to the Assembly License",
      501: "license number",
      502: "license date(d M yyyy)",
      503: "made date radio communication device (d M yyyy)",
    },
    insurance: "Insurance documents",
    ins_type: "Insurance type",
    ins_number: "Insurance number",
    ins_company_name: "Insurance company name",
    ins_limit: "Insurance coverage limit",
    ins_start: "Start Date",
    ins_end: "End Date",
    Profile: {
      registrantinformation: "Registrant information",
      title: "Title",
      FirstNamethai: "First Name(Thai)",
      LastNamethai: "Last Name(Thai)",
      idnum: "Identification Card",
      email: "email",
      phone: "phone",
      occupation: "Occupation",
      dateofbirth: "Date of Birth",
      age: "Age",
      nationality: "Nationality",
      ethnicity: "ethnicity",
      addressIdcard: "Address as per ID card or house registration",
      addresscurrent: "Currentaddress",
      address: "Address(Number, Village, Building, Village, Alley, Road)",
      province: "province",
      district: "district",
      subdistrict: "subdistrict",
      zipcode: "zip code",
    },
    uploaddocuments: "Upload Documents",
    identitydocuments: "Identity documents",
    copyidcard: "Copy of ID card",
    copyhouseregis: "Copy of house registration",
    technicaldocuments: "Technical specification documents",
    UAVPicture: "UAV’s picture",
    pictureDrone:
      "A photograph of the drone's serial number with a clear QR Code / Bar Code.",
    pictureremote:
      "A photograph of the remote controller's serial number with a clear QR Code / Bar Code",
    selfcertification: "Self-certification",
    copyinsdoc: "Copy of aircraft insurance documents",
    addsupportdoc:
      "Additional supporting documents in case of power of attorney",
    powerAttorneydocument: "Power of Attorney document",
    copyauthid: "Copy of ID card of the authorized person.",
    copyattornid: "Copy of ID card of the Attorney.",
    legaldoc: "Legal documents",
    legalresult: "Legal result",
    regisRID: {
      main: "Add Module/Network Remote ID",
      submain: "Network Remote ID information",
      ridname: "Remote ID Name",
      ridserial: "Remote ID Serial Number",
      ridmanufac: "Remote ID Manufacturer",
      addrid: "Add Remote ID",
    },
    statusdrone: { main: "Aircraft list" ,
      submain:"Drone registration status",
      number:"Request Number",
      brandmodel:"Brand-Model",
      status:"status",
      dateregis:"registration date",
      connectRID:"connect Remote ID",
      checkdata:"Information",
      payservice:"Pay service",
      mainRemote:"Remote List",
      submainRemote:"Remote ID Status",
      numberRemote:"Remote ID Number",
      nameRemote:"Remote ID Name",
      connectDrone:"Remote ID Connect Drone",
      deleteRID:"Remote ID Release"
    },
    pilotstatus:{
      main:"List Pilot Under affiliation",
      addpilot:"Add Pilot",
      list:"list",
      name:"Name",
      type:"Type",
      status:"Status",
      canclepilot:"Pilot removal",
      Search:"Search"
    },
    operationlist:{
      main:"Operation status",
      submain1:"My Operation",
      submain2:"Join Operation",
      headtitle:"List all Operations",
      successtitle:"List all completed Operations",
      OperationCode:"Operation Code",
      pilotandUAV:"Pilot/Aircraft",
      time:"Flight Operation Time",
      type:"Types of Flight",
      status:"Status",
      checkdata:"information",
      otc:"other",
      pilotjoin:"Operation Participant"
    },
    pilotregisopen:{
      main:"ขอใบขึ้นทะเบียนนักบิน",
      Profile: {
        registrantinformation: "ข้อมูลผู้ขอขึ้นทะเบียน",
        title: "คำนำหน้าชื่อ",
        FirstNamethai: "ชื่อ",
        LastNamethai: "นามสกุล",
        idnum: "เลขบัตรประชาชน",
        email: "อีเมล",
        phone: "เบอร์โทรศัพท์",
        occupation: "อาชีพ",
        dateofbirth: "วัน-เดือน-ปี เกิด",
        age: "อายุ",
        nationality: "สัญชาติ",
        ethnicity: "เชื้อชาติ",
        addressIdcard: "ที่อยู่ตามบัตรประชาชนหรือทะเบียนบ้าน",
        addresscurrent: "ที่อยู่ปัจจุบัน",
        address: "ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)",
        province: "จังหวัด",
        district: "อำเภอ",
        subdistrict: "ตำบล",
        zipcode: "รหัสไปรษณีย์",
      }
    },
    pilotregisspec:{
      main:"ขอใบขึ้นทะเบียนนักบินขั้นสูง",
      Profile: {
        registrantinformation: "ข้อมูลผู้ขอขึ้นทะเบียน",
        title: "คำนำหน้าชื่อ",
        FirstNamethai: "ชื่อ",
        LastNamethai: "นามสกุล",
        idnum: "เลขบัตรประชาชน",
        email: "อีเมล",
        phone: "เบอร์โทรศัพท์",
        occupation: "อาชีพ",
        dateofbirth: "วัน-เดือน-ปี เกิด",
        age: "อายุ",
        nationality: "สัญชาติ",
        ethnicity: "เชื้อชาติ",
        addressIdcard: "ที่อยู่ตามบัตรประชาชนหรือทะเบียนบ้าน",
        addresscurrent: "ที่อยู่ปัจจุบัน",
        address: "ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)",
        province: "จังหวัด",
        district: "อำเภอ",
        subdistrict: "ตำบล",
        zipcode: "รหัสไปรษณีย์",
      },
      cert:"ใบรับรอง",
      certstartdate:"วันที่เริ่มต้นใบอนุญาต",
      certenddate:"วันที่หมดอายุใบอนุญาต"
    },
    managementpilot:{
      main:"ManagePilot",
      submain1:"Pilot List",
      submain2:"Operator List",
      type:"Pilot type",
      number:"Pilot number",
      codeOpen:"OPEN Pilot Code",
      codeSpec:"SPECIFIC Pilot Code",
      list:"List",
      name:"name",
      status:"status",
      Delete:"delete"
    },
    statuspilot:{
      main:"Operation History",
      submain1:"My Operation",
      submain2:"Join Operation",
      title1:"List all Operations",
      title2:"List all completed Operations",
      codeoperation:"Operation Code",
      name:"Pilot/Aircraft",
      time:"Flight Operation Time",
      type:"Types of Flight",
      status:"Status",
      checkdata:"information",
      pilotjoin:"Operation Participant"
    },
    operationleaflet:{
      main:"สร้างแผนการบิน",
      submain:"แผนการบินแบบรูปทรง",
      submain2:"คำนวณแผนแบบเส้น",
      timestart:"เวลาเริ่มต้นการบิน",
      timeend:"เวลาสิ้นสุดการบิน",
      choosedrone:"เลือกอากาศยาน",
      chooseporpose:"เลือกวัตถุประสงค์การบิน",
      choosepilot:"เลือกนักบิน",
      altitude:"ตำแหน่งพื้นที่ | ความสูง",
      uploadfile:"อัพโหลดไฟล์ KML (ถ้ามี)",
      altitude2:"ตำแหน่งจุด A | ตำแหน่งจุด B | ความสูง",
    },
    joinope:{
      main:"Join Operation",
      submain:"my Operation",
      codejoin:"Operation code to be Joined",
      checkcode:"Check code",
      start:"Start time",
      end:"End time",
      choosedrone:"choosedrone",
      choosepurpose:"choosepurpose",
      choosepilot:"choosepilot"
    },
    searharea:{
      main:"Explore the flight area",
      submain1:"my Operation",
      submain2:"Check Operation",
      submain3:"other",
      title1s1:"Flight plan is underway",
      title2s1:"Flight plan completed",
      nodata1:"*** No flight plan information currently in operation found. ***",
      title1s2:"Date range you want to explore",
      title1s3:"Time of day to explore",
      startdate:"startdate",
      enddate:"enddate",
      today:"today",
      starttime:"starttime",
      endtime:"endtime",
      scope:"Select scope",
      flightnear:"flightnear",
      closearea:"closearea",
      tooltips:"*** Right click on the map to select an area. ***",
      nodata2:"*** Data not found in the time period you specified. ***",
      areaetc:"Other areas",
      checkclosearea:"Check all no-fly zones",
      forecast:"forecast",
      myope:"My operating area",
      ownerope:"Others' operating areas"
    }
  },
  th: {
    next: "ถัดไป",
    previous: "ย้อนกลับ",
    submitdata: "นำส่งข้อมูล",
    savedata: "บันทึกข้อมูล",
    welcome: "ยินดีต้อนรับ",
    language: "ภาษา",
    operator: "ผู้ดำเนินการ",
    pilot: "นักบิน",
    operation: "การปฏิบัติการ",
    registerdrone: "ขึ้นทะเบียนโดรน",
    registerremoteid: "ขึ้นทะเบียน Remote ID",
    managedrone: "จัดการโดรนในครอบครอง",
    managepilot: "จัดการนักบินในสังกัด",
    statusoperation: "สถานะการปฏิบัติการ",
    registerpilotopen: "ขึ้นทะเบียนนักบินทั่วไป",
    registerpilotspacific: "ขึ้นทะเบียนนักบินขั้นสูง",
    manageflightoperation: "จัดการการเข้าร่วมสังกัด",
    historyflight: "ประวัติการบิน",
    droneoperation: "สร้างแผนการบินโดรน",
    joinoperation: "เข้าร่วมแผนการบินกับหน่วยงาน",
    opeartiondisplay: "สำรวจพื้นที่ทำการบิน",
    monitoring: "ตรวจสอบการบิน",
    profile: "โปรไฟล์",
    logout: "ออกจากระบบ",
    registerRadio: "ขึ้นทะเบียนโดรน",
    droneinfo: "ข้อมูลอุปกรณ์โดรน",
    serialnumber: "หมายเลขซีเรียล",
    brand: "ตราสินค้า / ยี่ห้อ",
    model: "รุ่น",
    eq_install: "อุปกรณ์ที่ติดตั้งเสริม",
    weight: "น้ำหนัก (กิโลกรัม)",
    stdrid: "มี Built-in Remote ID ",
    frequency: {
      head: "คลื่นความถี่ (MHz) และกำลังส่งออกอากาศสมมูลแบบไอโซทรอปิก",
      1: "433.05 – 434.79 MHz กำลังส่งสูงสุด e.i.r.p. 10 mW",
      2: "2400 – 2500 MHz กำลังส่งสูงสุด e.i.r.p. 100 mW",
      3: "5725 – 5850 MHz กำลังส่งสูงสุด e.i.r.p. 1000 mW",
      4: "24.05 – 24.25 GHz กำลังส่งสูงสุด e.i.r.p. 100 mW",
    },
    purpose: {
      head: "วัตถุประสงค์ของการใช้อากาศยาน aircraft.",
      1: "เพื่อการเล่นเป็นงานอดิเรก ความบันเทิง หรือ เพื่อการกีฬา",
      2: "เพื่อการรายงานเหตุการณ์หรือรายงานจราจร (สื่อมวลชน)",
      3: "เพื่อการถ่ายภาพ ถ่ายทำหรือการแสดงในภาพยนต์หรือรายการโทรทัศน์",
      4: "เพื่อการเกษตรกรรม",
      5: "เพื่อการวิจัยและพัฒนาอากาศยาน เพื่อการพาณิชย์",
      6: "เพื่อการวิจัย ทดลอง ทดสอบ ตามประกาศ กสทช.",
      7: "กรณีมีวัตถุประสงค์อื่น ให้ระบุ",
      8: "สำรวจหรือตรวจสอบอาคาร",
      9: "สำรวจหรือถ่ายภาพทางอากาศ",
      10: "ปฏิบัติการเพื่อการจัดแสดง",
      11: "ปฏิบัติการบินเกินระยะสายตานักบินโดย ใช้ผู้ช่วยสังเกตการบิน (EVLOS)",
      12: "ปฏิบัติการในพื้นที่ปิด",
      13: "การจัดงานแข่งขันบินโดรน",
      etc: "อื่นๆโปรดระบุ",
      open1: "เพื่อวิจัย"
    },
    remote_sn: "หมายเลขประจำเครื่องอุปกรณ์ควบคุมการบิน",
    remote_brand: "แบรนด์อุปกรณ์ควบคุมการบิน",
    lic: {
      head: "วันที่ครอบครองเครื่องวิทยุคมนาคมที่ใช้ในอากาศยานซึ่งไม่มีนักบิน",
      1: "นำเข้าตามใบอนุญาตนำเข้า",
      101: "เลขใบอนุญาตนำเข้า",
      102: "วันที่นำเข้า (วัน/เดือน/ปี พ.ศ.)",
      2: "ซื้อจากร้านค้า",
      201: "ชื่อร้านค้า",
      202: "ตามใบเสร็จ/ใบกำกับภาษี ลงวันที่ (วัน/เดือน/ปี พ.ศ.)",
      3: "นำเข้ามาใช้งานในประเทศเป็นการชั่วคราว",
      301: "วันที่เดินทางเข้าประเทศไทย/ Arrival date (mm dd, yyyy)",
      302: "จำนวนวันที่พำนักในประเทศไทย (วัน)",
      4: "รับโอนจากบุคคลอื่น",
      5: "ทำขึ้นตามใบอนุญาต",
      501: "เลขที่ใบอนุญาตทำ",
      502: "วันที่ใบอนุญาตทำ (วัน/เดือน/ปี พ.ศ.)",
      503: "วันที่ทำเครื่องวิทยุคมนาคม (วัน/เดือน/ปี พ.ศ.)",
    },
    insurance: "เอกสารการประกันภัย",
    ins_type: "ประเภทกรมธรรม์",
    ins_number: "เลขกรมธรรม์",
    ins_company_name: "ชื่อบริษัทประกัน",
    ins_limit: "วงเงินประกัน(ประกันภัยบุคคลที่ 3 วงเงินไม่ต่ำกว่า1ล้านบาท)",
    ins_start: "ระยะเวลาเริ่มประกัน",
    ins_end: "ระยะเวลาสิ้นสุดประกัน",
    Profile: {
      registrantinformation: "ข้อมูลผู้ขอขึ้นทะเบียน",
      title: "คำนำหน้าชื่อ",
      FirstNamethai: "ชื่อ",
      LastNamethai: "นามสกุล",
      idnum: "เลขบัตรประชาชน",
      email: "อีเมล",
      phone: "เบอร์โทรศัพท์",
      occupation: "อาชีพ",
      dateofbirth: "วัน-เดือน-ปี เกิด",
      age: "อายุ",
      nationality: "สัญชาติ",
      ethnicity: "เชื้อชาติ",
      addressIdcard: "ที่อยู่ตามบัตรประชาชนหรือทะเบียนบ้าน",
      addresscurrent: "ที่อยู่ปัจจุบัน",
      address: "ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)",
      province: "จังหวัด",
      district: "อำเภอ",
      subdistrict: "ตำบล",
      zipcode: "รหัสไปรษณีย์",
    },

    uploaddocuments: "เอกสารที่นำส่ง",
    identitydocuments: "เอกสารแสดงตน",
    copyidcard: "สำเนาบัตรประจำตัวประชาชน",
    copyhouseregis: "สำเนาทะเบียนบ้าน",
    technicaldocuments: "เอกสารแสดงลักษณะทางเทคนิค",
    UAVPicture: "รูปถ่ายของ Drone",
    pictureDrone:
      "รูปถ่ายหมายเลขประจำเครื่อง Drone ที่เห็น QR CODE/Bar Code ที่ชัดเจน",
    pictureremote:
      "รูปถ่ายหมายเลขประจำเครื่องอุปกรณ์ควบคุมการบิน Drone ที่เห็น QR CODE/Bar Code ที่ชัดเจน",
    selfcertification: "หนังสือรับรองตนเอง",
    copyinsdoc: "สำเนาเอกสารประกันภัยอากาศยาน",
    addsupportdoc: "เอกสารหลักฐานเพิ่มเติมกรณีมอบอำนาจ",
    powerAttorneydocument: "หนังสือมอบอำนาจ",
    copyauthid: "สำเนาบัตรประจำตัวประชาชนผู้มอบอำนาจ",
    copyattornid: "สำเนาบัตรประจำตัวประชาชนผู้รับมอบอำนาจ",
    legaldoc: "เอกสารดำเนินคดี",
    legalresult: "ผลการดำเนินคดี",
    regisRID: {
      main: "ขึ้นทะเบียน Remote ID",
      submain: "ข้อมูล Network Remote ID",
      ridname: "ชื่อ Remote ID",
      ridserial: "หมายเลข Remote ID",
      ridmanufac: "ยี่ห้อ Remote ID",
      addrid: "เพิ่ม Remote ID",
      
    },
    statusdrone: { main: "รายการโดรนในครอบครอง" ,
      submain:"สถานะการขึ้นทะเบียนโดรน",
      number:"เลขที่คำขอ",
      brandmodel:"แบรนด์-รุ่น",
      status:"สถานะการทำรายการ",
      dateregis:"วันที่ขอขึ้นทะเบียน",
      connectRID:"เชื่อมต่อ Remote ID",
      checkdata:"ตรวจสอบข้อมูล",
      payservice:"ชำระค่าบริการ",
      mainRemote:"รายการ Remote ID ในครอบครอง",
      submainRemote:"สถานะ Remote ID",
      numberRemote:"หมายเลขประจำเครื่อง Remote ID",
      nameRemote:"ชื่อ Remote ID",
      connectDrone:"โดรนที่เชื่อมต่อกับ Remote ID",
      deleteRID:"ปลดการครอบครอง Remote ID"
    },
    pilotstatus:{
      main:"รายการนักบินที่ในสังกัด",
      addpilot:"เพิ่มนักบิน",
      list:"ลำดับ",
      name:"ชื่อ",
      type:"ประเภทการบิน",
      status:"สถานะการบิน",
      canclepilot:"ถอนนักบิน",
      Search:"ค้นหา"
    },
    operationlist:{
      main:"สถานะการปฏิบัติการ",
      submain1:"ปฏิบัติการของฉัน",
      submain2:"ปฏิบัติการพิเศษ",
      headtitle:"รายการปฏิบัติการ",
      successtitle:"รายการปฏิบัติการที่เสร็จสิ้น",
      OperationCode:"รหัสการปฏิบัติการ",
      pilotandUAV:"ผู้บังคับ/อากาศยาน",
      time:"เวลาปฏิบัติการบิน",
      type:"ประเภทของการบิน",
      status:"สถานะ",
      checkdata:"ตรวจสอบข้อมูล",
      otc:"อื่นๆ",
      pilotjoin:"ผู้เข้าร่วมปฏิบัติการ"
    },
    pilotregisopen:{
      main:"ขอใบขึ้นทะเบียนนักบิน",
      Profile: {
        registrantinformation: "ข้อมูลผู้ขอขึ้นทะเบียน",
        title: "คำนำหน้าชื่อ",
        FirstNamethai: "ชื่อ",
        LastNamethai: "นามสกุล",
        idnum: "เลขบัตรประชาชน",
        email: "อีเมล",
        phone: "เบอร์โทรศัพท์",
        occupation: "อาชีพ",
        dateofbirth: "วัน-เดือน-ปี เกิด",
        age: "อายุ",
        nationality: "สัญชาติ",
        ethnicity: "เชื้อชาติ",
        addressIdcard: "ที่อยู่ตามบัตรประชาชนหรือทะเบียนบ้าน",
        addresscurrent: "ที่อยู่ปัจจุบัน",
        address: "ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)",
        province: "จังหวัด",
        district: "อำเภอ",
        subdistrict: "ตำบล",
        zipcode: "รหัสไปรษณีย์",
      }
    },
    pilotregisspec:{
      main:"ขอใบขึ้นทะเบียนนักบินขั้นสูง",
      Profile: {
        registrantinformation: "ข้อมูลผู้ขอขึ้นทะเบียน",
        title: "คำนำหน้าชื่อ",
        FirstNamethai: "ชื่อ",
        LastNamethai: "นามสกุล",
        idnum: "เลขบัตรประชาชน",
        email: "อีเมล",
        phone: "เบอร์โทรศัพท์",
        occupation: "อาชีพ",
        dateofbirth: "วัน-เดือน-ปี เกิด",
        age: "อายุ",
        nationality: "สัญชาติ",
        ethnicity: "เชื้อชาติ",
        addressIdcard: "ที่อยู่ตามบัตรประชาชนหรือทะเบียนบ้าน",
        addresscurrent: "ที่อยู่ปัจจุบัน",
        address: "ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)",
        province: "จังหวัด",
        district: "อำเภอ",
        subdistrict: "ตำบล",
        zipcode: "รหัสไปรษณีย์",
      },
      cert:"ใบรับรอง",
      certstartdate:"วันที่เริ่มต้นใบอนุญาต",
      certenddate:"วันที่หมดอายุใบอนุญาต"
    },
    managementpilot:{
      main:"จัดการเข้าร่วมสังกัด",
      submain1:"รายการนักบิน",
      submain2:"รายการสังกัดที่เข้าร่วม",
      type:"ประเภทนักบิน",
      number:"หมายเลขนักบิน",
      codeOpen:"รหัสนักบิน OPEN",
      codeSpec:"รหัสนักบิน SPECIFIC",
      list:"ลำดับ",
      codepilot:"หมายเลขผู้ปฏิบัติการบิน",
      name:"ชื่อ - สกุล",
      status:"สถานะคำขอ",
      Delete:"ออกจากสังกัด"
    },
    statuspilot:{
      main:"ประวัติการบิน",
      submain1:"การบินของฉัน",
      submain2:"ปฏิบัติการพิเศษ",
      title1:"รายการการบินที่กำลังดำเนินการ",
      title2:"รายการการบินที่เสร็จสิ้น",
      codeoperation:"รหัสปฏิบัติการ",
      name:"ผู้ดำเนินการ/อากาศยาน",
      time:"เวลาการบิน",
      type:"ประเภทการบิน",
      status:"สถานะ",
      checkdata:"ตรวจสอบข้อมูล",
    },
    operationleaflet:{
      main:"สร้างแผนการบิน",
      submain:"แผนการบินแบบรูปทรง",
      submain2:"คำนวณแผนแบบเส้น",
      timestart:"เวลาเริ่มต้นการบิน",
      timeend:"เวลาสิ้นสุดการบิน",
      choosedrone:"เลือกอากาศยาน",
      chooseporpose:"เลือกวัตถุประสงค์การบิน",
      choosepilot:"เลือกนักบิน",
      altitude:"ตำแหน่งพื้นที่ | ความสูง",
      uploadfile:"อัพโหลดไฟล์ KML (ถ้ามี)",
      altitude2:"ตำแหน่งจุด A | ตำแหน่งจุด B | ความสูง",
    },
    joinope:{
      main:"เข้าร่วมแผนการบิน",
      submain:"แผนการบินของคุณ",
      codejoin:"รหัสการปฏิบัติที่ต้องการเข้าร่วม",
      checkcode:"ตรวจสอบรหัสการเข้าร่วม",
      start:"เวลาเริ่มต้น",
      end:"เวลาสิ้นสุด",
      choosedrone:"เลือกอากาศยาน",
      chooseporpose:"เลือกวัตถุประสงค์การบิน",
      choosepilot:"เลือกนักบิน"
    },
    searharea:{
      main:"สำรวจพื้นที่ทำการบิน",
      submain1:"แผนการบินของคุณ",
      submain2:"ตรวจสอบพื้นที่การบิน",
      submain3:"อื่นๆ",
      title1s1:"แผนการบินกำลังดำเนินการ",
      title2s1:"แผนการบินเสร็จสิ้นภารกิจ",
      nodata1:"*** ไม่พบข้อมูลแผนการบินที่กำลังทำการ ***",
      title1s2:"ช่วงวันที่ต้องการสำรวจ",
      title1s3:"ช่วงเวลาในแต่ละวันที่ต้องการสำรวจ",
      startdate:"วันที่เริ่มต้น",
      enddate:"วันที่สิ้นสุด",
      today:"วันนี้",
      starttime:"เวลาเริ่มต้น",
      endtime:"เวลาสิ้นสุด",
      scope:"เลือกขอบเขต",
      flightnear:"แผนการบินใกล้คุณ",
      closearea:"พื้นที่หวงห้าม",
      tooltips:"*** คลิกขวาบนแผนที่เพื่อเลือกพื้นที่ ***",
      nodata2:"*** ไม่พบข้อมูล ในช่วงเวลาที่คุณกำหนด ***",
      areaetc:"พื้นที่อื่นๆ",
      checkclosearea:"ตรวจสอบพื้นที่ห้ามบินทั้งหมด",
      forecast:"สภาพอากาศ",
      myope:"พื้นที่ปฏิบัติการของฉัน",
      ownerope:"พื้นที่ปฏิบัติการของผู้อื่น"
    }
  },
};

export default translations;
